import { Layout, Menu, Tabs } from 'antd';
import { darken, lighten } from 'polished';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  min-height: 100vh; 
`;

export const Sider = styled(Layout.Sider)`
  background-color: #f78e1e;
  height: 100vh;
  overflow-y: auto;
  position: sticky;
  top: 0;
  transition: transform 0.25s ease;

  .ant-layout-sider-trigger {
    background-color: ${darken(0.05, '#F78E1E')};
    display: ${props => (props.className?.includes('isMobile') ? 'none' : 'block')};
  }

  & > .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${darken(0.2, '#F78E1E')};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f78e1e;
  }

  &.isMobile {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1001;
    max-width: 256px !important;
    min-width: 256px !important;
    width: 256px !important;
    flex: 0 0 256px !important;
    transform: translateX(-100%);

    &.mobileOpen {
      transform: translateX(0);
      box-shadow: 2px 0 12px rgba(0, 0, 0, 0.25);
    }
  }
`;

export const MobileHeader = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 52px;
  background-color: #f78e1e;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  z-index: 1002;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
`;

export const MobileLogo = styled.img`
  height: 36px;
  width: auto;
  object-fit: contain;
`;

export const HamburgerButton = styled.button`
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 6px;
  background-color: transparent;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;

  &:hover {
    background-color: ${darken(0.05, '#F78E1E')};
  }
`;

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.45);
  z-index: 1000;
`;

export const MenuContainer = styled(Menu)`
  background-color: #f78e1e;
  flex-grow: 1;
`;

export const Content = styled.div`
  flex: 1; 
  height: 100vh; 
  overflow-y: auto; 
  background-color: #fff;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f5f5f5;
  }
`;

export const Logo = styled.div`
  padding: 0 60px 0 60px;
  margin-top: -10px;
  margin-bottom: -30px;
  text-align: center;

  &.collapsed {
    margin-bottom: 20px;
    padding: 10px 0 0 0;

    img {
      margin-bottom: -20px;
      width: 50px;
      height: 50px;
    }
  }

  img {
    height: 100px;
    width: 100px;
    object-fit: contain;
  }
`;

export const MenuItem = styled(Menu.Item)`
  background-color: #f78e1e;
  padding: 5px 10px 0 10px;
  font: 13px 'Roboto', sans-serif;
  color: #fff;
  font-weight: 400;

  &:hover {
    background-color: ${lighten(0.1, '#F78E1E')};
    color: #fff;
  }
`;

export const MenuGroup = styled(Menu.ItemGroup)`
  background-color: #f78e1e;

  .ant-menu-item-group-title {
    display: ${props => (props.className === 'collapsed' ? 'none' : 'block')};
    font: 13px 'Roboto', sans-serif !important;
    color: #fbfcfe;
    font-weight: 500;
    text-transform: uppercase;
  }
`;

export const SubMenu = styled(Menu.SubMenu)`
  background-color: #f78e1e;
  font: 13px 'Roboto', sans-serif !important;
  color: #fff;

  &:hover {
    color: #fff;
  }

  .ant-menu-submenu-arrow {
    color: #fff;

    &:hover {
      color: #fff;
    }
  }
`;

export const closeButtonStyle = {
  marginLeft: 12,
  display: 'flex',
  alignItems: 'center'
};

export const ProfileContent = styled.div`
  width: 100%;
  max-width: 256px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  bottom: 117px;
  z-index: 1;

  &.collapsed {
    max-width: 80px;
  }

  &.isMobile {
    bottom: 48px;
  }

  svg {
    font-size: 16px;
    margin-right: 12px;
    color: #fff;
  }
  div {
    width: 100%;
    padding-bottom: 5px;
    padding: 0 0px 0 0px;
  }
`;

export const ProfileName = styled.span`
  text-align: left;
  font: 14px 'Roboto', sans-serif;
  font-weight: 400;
  color: #fff;
  cursor: pointer;
`;

export const TabContainer = styled(Tabs)`
  padding: 0 24px;

  &.no-tabs {
    padding: 24px;
  }

  &.tab-padding {
    padding-bottom: 0;
  }
`;

export const TabGuideStyle = {
  marginBottom: 0
};

export const TabsStyle = {
  padding: '24px 0'
};